var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2136_1768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 1.33331C6.68147 1.33331 5.39254 1.72431 4.29621 2.45685C3.19988 3.18939 2.3454 4.23058 1.84082 5.44876C1.33623 6.66693 1.20421 8.00738 1.46144 9.30058C1.71868 10.5938 2.35362 11.7817 3.28597 12.714C4.21832 13.6464 5.4062 14.2813 6.69941 14.5385C7.99262 14.7958 9.33306 14.6638 10.5512 14.1592C11.7694 13.6546 12.8106 12.8001 13.5431 11.7038C14.2757 10.6075 14.6667 9.31852 14.6667 7.99998C14.6667 7.1245 14.4942 6.25759 14.1592 5.44876C13.8242 4.63992 13.3331 3.90499 12.7141 3.28593C12.095 2.66688 11.3601 2.17581 10.5512 1.84078C9.7424 1.50575 8.87549 1.33331 8.00001 1.33331ZM8.00001 13.3333C6.94518 13.3333 5.91403 13.0205 5.03697 12.4345C4.15991 11.8484 3.47632 11.0155 3.07266 10.041C2.66899 9.06642 2.56337 7.99406 2.76916 6.9595C2.97495 5.92493 3.4829 4.97462 4.22878 4.22874C4.97466 3.48286 5.92497 2.97491 6.95953 2.76912C7.9941 2.56334 9.06645 2.66895 10.041 3.07262C11.0155 3.47629 11.8485 4.15988 12.4345 5.03694C13.0206 5.914 13.3333 6.94515 13.3333 7.99998C13.3333 9.41447 12.7714 10.771 11.7712 11.7712C10.7711 12.7714 9.4145 13.3333 8.00001 13.3333Z",
    fill: "#1B1C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 11.3333C8.36818 11.3333 8.66666 11.0349 8.66666 10.6667C8.66666 10.2985 8.36818 10 7.99999 10C7.63181 10 7.33333 10.2985 7.33333 10.6667C7.33333 11.0349 7.63181 11.3333 7.99999 11.3333Z",
    fill: "#1B1C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 4.66669C7.82318 4.66669 7.65361 4.73693 7.52859 4.86195C7.40357 4.98697 7.33333 5.15654 7.33333 5.33335V8.66669C7.33333 8.8435 7.40357 9.01307 7.52859 9.13809C7.65361 9.26312 7.82318 9.33335 7.99999 9.33335C8.17681 9.33335 8.34638 9.26312 8.4714 9.13809C8.59642 9.01307 8.66666 8.8435 8.66666 8.66669V5.33335C8.66666 5.15654 8.59642 4.98697 8.4714 4.86195C8.34638 4.73693 8.17681 4.66669 7.99999 4.66669Z",
    fill: "#1B1C1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2136_1768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotice);
export default __webpack_public_path__ + "static/media/icon_notice.8600d72a71b68919c93a6d3c1ddb3841.svg";
export { ForwardRef as ReactComponent };